"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRadioButtonWrapper = exports.FormErrorMessage = exports.StyledDatePickerWrapper = exports.StyledTimeInputWrapper = exports.InputWrapper = exports.StyledInput = exports.StyledTextarea = exports.StyledLabelLink = exports.StyledRadioFill = exports.StyledRadioButton = exports.RadioWrapper = exports.StyledCheckbox = exports.CheckboxWrapper = exports.StyledPill = exports.SelectorBox = exports.SelectorWrapper = exports.StyledDropdownOption = exports.StyledDropdown = exports.StyledLabel = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactDatePicker = _interopRequireDefault(require("react-date-picker"));

var _reactTimePicker = _interopRequireDefault(require("react-time-picker"));

var _StyledLink = _interopRequireDefault(require("../../StyledLink"));

var _checkmark_blue = _interopRequireDefault(require("../../../assets/icons/checkmark_blue.svg"));

var _checkmark_multiple = _interopRequireDefault(require("../../../assets/icons/checkmark_multiple.svg"));

var _CheckmarkWhite = _interopRequireDefault(require("../../../assets/icons/CheckmarkWhite.svg"));

var _chevronDown = _interopRequireDefault(require("../../../assets/icons/chevronDown.svg"));

var _GenericInput = require("./GenericInput");

var _GenericTextarea = require("./GenericTextarea");

var _StyledTypography = require("../../StyledTypography");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var sublabelStyling = (0, _styledComponents.css)(["&.sublabel{", ";color:", ";}"], _StyledTypography.paragraphSmallStyling, function (props) {
  return props.theme.mediumGrey;
});

var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "Elements__StyledLabel",
  componentId: "sc-48xv3y-0"
})(["", ";display:flex;align-items:center;color:", ";width:", ";margin-bottom:", ";> span > a,&.sublabel{", ";}"], _StyledTypography.paragraphSmallStyling, function (props) {
  return props.theme.mediumGrey;
}, function (props) {
  return "".concat(props.labelWidth) || 'inherit';
}, function (props) {
  return props.theme.spacingXxs;
}, sublabelStyling);

exports.StyledLabel = StyledLabel;

var StyledDropdown = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledDropdown",
  componentId: "sc-48xv3y-1"
})(["width:100%;height:44px;border:1px solid ", ";border-radius:4px;display:flex;align-items:center;padding:", ";background-image:url(", ");background-repeat:no-repeat;background-position:right 16px center;user-select:none;.form-error &{border:1px solid ", ";}> label{margin-bottom:0px;&.placeholder{color:", "}}"], function (props) {
  return props.theme.borderColorDefault;
}, function (props) {
  return props.noPadding ? '0px' : '12px 16px';
}, _chevronDown["default"], function (props) {
  return props.theme.negativeRed;
}, function (props) {
  return props.theme.mediumGrey;
});

exports.StyledDropdown = StyledDropdown;

var StyledDropdownOption = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledDropdownOption",
  componentId: "sc-48xv3y-2"
})(["width:100%;display:flex;flex-direction:column;background-repeat:no-repeat;background-image:", ";background-position:right 16px center;background-size:16px;background-color:", ";", ":hover{label{color:", " !important;}background-image:", ";background-color:", ";}> label{margin-bottom:0px;font-size:", ";}padding:8px 16px;"], function (props) {
  return props.checked && "url(".concat(_checkmark_blue["default"], ")") || 'none';
}, function (props) {
  return props.active ? props.theme.buttonColorPrimary : 'initial';
}, function (props) {
  return props.active && (0, _styledComponents.css)(["label{color:", " !important;}background-image:", ";"], props.theme.white, props.checked && "url(".concat(_CheckmarkWhite["default"], ")") || 'none');
}, function (props) {
  return props.theme.white;
}, function (props) {
  return props.checked && "url(".concat(_CheckmarkWhite["default"], ")");
} || 'none', function (props) {
  return props.theme.buttonColorPrimary;
}, function (props) {
  return props.theme.fontSizeBody;
});

exports.StyledDropdownOption = StyledDropdownOption;

var SelectorWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Elements__SelectorWrapper",
  componentId: "sc-48xv3y-3"
})(["width:100%;max-width:", ";"], function (props) {
  return props.theme.formInputMaxWidth;
});

exports.SelectorWrapper = SelectorWrapper;

var SelectorBox = _styledComponents["default"].div.withConfig({
  displayName: "Elements__SelectorBox",
  componentId: "sc-48xv3y-4"
})(["display:flex;flex-direction:column;border:1px solid ", ";border-radius:4px;padding-top:16px;.form-error &{border:1px solid ", ";}input{font-size:16px;outline:0px;height:16px;border:0px;padding-left:16px;padding-right:16px;}> div:first-of-type{border-bottom:1px solid ", ";min-height:70px;}> div{padding:16px;display:flex;flex-wrap:wrap;min-height:45px;> label{flex:1 0 100%;font-size:14px;}.loading-box,.info-box{font-size:14px;display:flex;flex-wrap:nowrap;align-items:center;width:100%;color:", ";height:24px;.loading-spinner,span:first-child{height:16px;width:16px;margin-right:8px;i{height:16px;width:16px;font-size:16px;}}}}"], function (props) {
  return props.theme.borderColorDefault;
}, function (props) {
  return props.theme.negativeRed;
}, function (props) {
  return props.theme.borderColorDefault;
}, function (props) {
  return props.theme.veryDarkGrey;
});

exports.SelectorBox = SelectorBox;

var StyledPill = _styledComponents["default"].span.withConfig({
  displayName: "Elements__StyledPill",
  componentId: "sc-48xv3y-5"
})(["", ";display:inline-flex;height:36px;align-items:center;border:1px solid ", ";padding:8px;border-radius:8px;margin-right:8px;margin-bottom:8px;", ";.plus{margin-right:8px;path{", ";}}.close{margin-left:8px;}span{height:14px;width:14px;svg{height:14px;width:14px;}}"], _StyledTypography.paragraphSmallStyling, function (props) {
  return props.primary ? props.theme.buttonBorderColorPrimary : props.theme.borderColorDefault;
}, function (props) {
  return props.primary && "color: ".concat(props.theme.buttonBorderColorPrimary);
}, function (props) {
  return props.primary && "fill: ".concat(props.theme.buttonBorderColorPrimary);
});

exports.StyledPill = StyledPill;

var CheckboxWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Elements__CheckboxWrapper",
  componentId: "sc-48xv3y-6"
})(["max-width:", ";width:100%;display:flex;align-items:flex-start;> div{display:flex;flex-direction:column;margin-left:", ";}", "{cursor:pointer;", ";margin-bottom:0px;color:", ";&.sublabel{", ";}}"], function (props) {
  return props.theme.formInputMaxWidth;
}, function (props) {
  return props.theme.spacingXs;
}, StyledLabel, _StyledTypography.paragraphStyling, function (props) {
  return props.theme.veryDarkGrey;
}, sublabelStyling);

exports.CheckboxWrapper = CheckboxWrapper;

var StyledCheckbox = _styledComponents["default"].span.withConfig({
  displayName: "Elements__StyledCheckbox",
  componentId: "sc-48xv3y-7"
})(["margin:0;border:", " solid ", ";border-radius:", ";cursor:pointer;background-image:", ";min-height:24px;min-width:24px;background-position:center;background-repeat:no-repeat;background-size:16px;background-color:", ";&:active{border:", " solid ", ";}", " ", ""], function (props) {
  return props.theme.borderStrokeThick;
}, function (props) {
  return props.theme.borderColorDefault;
}, function (props) {
  return props.theme.borderRadiusSm;
}, function (props) {
  return (props.multipleChecked ? "url(".concat(_checkmark_multiple["default"], ")") : props.checked && "url(".concat(_checkmark_blue["default"], ")")) || 'none';
}, function (props) {
  return props.theme.bgColor;
}, function (props) {
  return props.theme.borderStrokeThick;
}, function (props) {
  return props.theme.formActiveColor;
}, function (props) {
  return props.error && (0, _styledComponents.css)(["border:", " solid ", ";"], props.theme.borderStrokeThick, props.theme.formErrorColor);
}, function (props) {
  return props.center && (0, _styledComponents.css)(["align-self:center;margin-bottom:32px;"]);
});

exports.StyledCheckbox = StyledCheckbox;

var RadioWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Elements__RadioWrapper",
  componentId: "sc-48xv3y-8"
})(["max-width:", ";width:100%;display:flex;flex-direction:column;> div{margin-top:4px;}.radio-button-wrapper{display:flex;margin-bottom:14px;align-items:center;}", "{", ";margin-bottom:0px;color:", ";&.sublabel{", ";}}"], function (props) {
  return props.theme.formInputMaxWidth;
}, StyledLabel, _StyledTypography.paragraphStyling, function (props) {
  return props.theme.veryDarkGrey;
}, sublabelStyling);

exports.RadioWrapper = RadioWrapper;

var StyledRadioButton = _styledComponents["default"].span.withConfig({
  displayName: "Elements__StyledRadioButton",
  componentId: "sc-48xv3y-9"
})(["border:2px solid ", ";border-radius:50%;min-height:24px;min-width:24px;width:24px;display:flex;align-items:center;justify-content:center;height:24px;margin-right:", ";.form-error &{border:1px solid ", ";}"], function (props) {
  return props.theme.borderColorDefault;
}, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return props.theme.negativeRed;
});

exports.StyledRadioButton = StyledRadioButton;

var StyledRadioFill = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledRadioFill",
  componentId: "sc-48xv3y-10"
})(["width:16px;height:16px;border-radius:50%;background-color:", ";"], function (props) {
  return props.theme.primaryBlue;
});

exports.StyledRadioFill = StyledRadioFill;
var StyledLabelLink = (0, _styledComponents["default"])(_StyledLink["default"]).withConfig({
  displayName: "Elements__StyledLabelLink",
  componentId: "sc-48xv3y-11"
})(["color:", " !important;"], function (props) {
  return props.theme.linkColorDefault;
});
exports.StyledLabelLink = StyledLabelLink;
var StyledTextarea = (0, _styledComponents["default"])(_GenericTextarea.GenericTextarea).withConfig({
  displayName: "Elements__StyledTextarea",
  componentId: "sc-48xv3y-12"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";flex:0 0 auto;padding:12px ", ";height:", ";color:", ";", " .form-error &{border:1px solid ", ";}&:focus{outline:none;border-color:", ";}"], function (props) {
  return props.theme.white;
}, function (props) {
  return props.theme.borderColorDefault;
}, function (props) {
  return props.theme.borderRadiusSm;
}, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.height ? "".concat(props.height, "px") : '132px';
}, function (props) {
  return props.theme.veryDarkGrey;
}, function (props) {
  return props.height && (0, _styledComponents.css)(["resize:none;"]);
}, function (props) {
  return props.theme.negativeRed;
}, function (props) {
  return props.theme.borderColorFocus;
});
exports.StyledTextarea = StyledTextarea;
var StyledInput = (0, _styledComponents["default"])(_GenericInput.GenericInput).withConfig({
  displayName: "Elements__StyledInput",
  componentId: "sc-48xv3y-13"
})(["background-color:", ";border:", ";border-radius:", ";height:", ";font-size:", ";padding:12px ", ";flex:0 0 auto;color:", ";width:", ";.form-error &{border:1px solid ", ";}"], function (props) {
  return !props.transparentBg ? props.theme.white : 'transparent';
}, function (props) {
  return !props.noBorder ? "1px solid ".concat(props.theme.borderColorDefault) : 'none';
}, function (props) {
  return props.theme.borderRadiusSm;
}, function (props) {
  return props.theme.formInputHeight;
}, function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.veryDarkGrey;
}, function (props) {
  return !props.fullWidth ? 'initial' : '100%';
}, function (props) {
  return props.theme.negativeRed;
});
exports.StyledInput = StyledInput;

var InputWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Elements__InputWrapper",
  componentId: "sc-48xv3y-14"
})(["max-width:", ";width:100%;display:flex;flex-direction:column;flex:0 0 auto;position:relative;.clear{position:absolute;bottom:calc(50% - 8px);right:16px;line-height:1;height:14px;width:14px;svg{width:14px;height:14px;path{fill:rgba(0,0,0,0.65);}}}"], function (props) {
  return props.theme.formInputMaxWidth;
});

exports.InputWrapper = InputWrapper;
var StyledTimeInputWrapper = (0, _styledComponents["default"])(_reactTimePicker["default"]).withConfig({
  displayName: "Elements__StyledTimeInputWrapper",
  componentId: "sc-48xv3y-15"
})([".react-time-picker__wrapper{background-color:", ";border:", ";border-radius:", ";height:", ";font-size:", ";line-height:", ";padding:12px ", ";flex:0 0 auto;color:", ";width:100%;.react-time-picker__inputGroup{span:nth-last-of-type(2){display:", ";}}.react-time-picker__inputGroup__input{&.react-time-picker__inputGroup__input--hasLeadingZero{margin:0;}padding:0;}.form-error &{border:1px solid ", ";}input[type=\"number\"]{-webkit-appearance:none;-moz-appearance:textfield;}select{-webkit-appearance:none;-moz-appearance:none;}input[type=\"number\"]::-webkit-outer-spin-button,input[type=\"number\"]::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;}input[type=\"number\"]::-webkit-clear-button{display:none;}}"], function (props) {
  return !props.transparentBg ? props.theme.white : 'transparent';
}, function (props) {
  return !props.noBorder ? "1px solid ".concat(props.theme.borderColorDefault) : 'none';
}, function (props) {
  return props.theme.borderRadiusSm;
}, function (props) {
  return props.theme.formInputHeight;
}, function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.veryDarkGrey;
}, function (props) {
  return props.disableZeroPadding && 'none' || 'initial';
}, function (props) {
  return props.theme.negativeRed;
});
exports.StyledTimeInputWrapper = StyledTimeInputWrapper;
var StyledDatePickerWrapper = (0, _styledComponents["default"])(_reactDatePicker["default"]).withConfig({
  displayName: "Elements__StyledDatePickerWrapper",
  componentId: "sc-48xv3y-16"
})([".react-date-picker__wrapper{background-color:", ";border:", ";border-radius:", ";height:", ";font-size:", ";line-height:", ";padding:12px ", ";flex:0 0 auto;color:", ";width:100%;.react-date-picker__inputGroup__input{&.react-date-picker__inputGroup__input--hasLeadingZero{margin:0;}padding:0;}.form-error &{border:1px solid ", ";}input[type=\"number\"]{-webkit-appearance:none;-moz-appearance:textfield;}input[type=\"number\"]::-webkit-outer-spin-button,input[type=\"number\"]::-webkit-inner-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0;}input[type=\"number\"]::-webkit-clear-button{display:none;}}"], function (props) {
  return !props.transparentBg ? props.theme.white : 'transparent';
}, function (props) {
  return !props.noBorder ? "1px solid ".concat(props.theme.borderColorDefault) : 'none';
}, function (props) {
  return props.theme.borderRadiusSm;
}, function (props) {
  return props.theme.formInputHeight;
}, function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.fontSizeBody;
}, function (props) {
  return props.theme.spacingSm;
}, function (props) {
  return props.theme.veryDarkGrey;
}, function (props) {
  return props.theme.negativeRed;
});
exports.StyledDatePickerWrapper = StyledDatePickerWrapper;

var FormErrorMessage = _styledComponents["default"].span.withConfig({
  displayName: "Elements__FormErrorMessage",
  componentId: "sc-48xv3y-17"
})(["", ";min-height:24px;width:100%;display:flex;color:", ";text-transform:none;margin-bottom:0;", ""], _StyledTypography.paragraphSmallStyling, function (props) {
  return props.theme.negativeRed;
}, function (props) {
  return props.noSpacing && (0, _styledComponents.css)(["min-height:0;"]);
});

exports.FormErrorMessage = FormErrorMessage;

var StyledRadioButtonWrapper = _styledComponents["default"].div.withConfig({
  displayName: "Elements__StyledRadioButtonWrapper",
  componentId: "sc-48xv3y-18"
})(["opacity:", ";"], function (props) {
  return props.disabled ? '0.5' : '1';
});

exports.StyledRadioButtonWrapper = StyledRadioButtonWrapper;